<template>
  <div class="openid-add">
    <OpenidForm operate="add" />
  </div>
</template>

<script>
import OpenidForm from './OpenidForm'
export default {
  name: 'openid-add',

  components: {
    OpenidForm
  }
}
</script>

